import React, {useContext, useRef, useState} from 'react';
import {IProps} from './types';
import * as S from './styles';
import Options from '@components/Options';
import BlackCheckIcon from '@assets/icons/blackCheckIcon';
import WarningIcon from '@assets/icons/warningIcon';
import NotDescribed from '@assets/icons/notDescribed';
import { getOEMName } from 'utils/editor';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import FullPreview from '@routes/private/Studio/components/FullPreview';
import { TemplatesContext } from '@utils/DOIgnition/TemplatesContext';
import OptionIcon from '@assets/icons/optionIcon';
import { ITemplate } from '@state/templates/types';

const ItemTemplate:React.FC<IProps> = ({item, idx, onActionsTemplate, selected, setOpen, handleSelectedIndexes}) => {
  const templateContext = useContext(TemplatesContext)
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const textName = useRef() as React.MutableRefObject<HTMLInputElement>;
  const textTags = useRef() as React.MutableRefObject<HTMLInputElement>;
  const textState = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [tootltipName, showTooltipname]= useState(false);
  const [tootltipTags, showTooltiptag]= useState(false);
  const [tootltipState, showTooltipstate]= useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [coordinates, setCoordinates] = useState({x: 0, y: 0});
  const [viewPreview, setViewPreview] = useState(false);

  const handleActionsTemplate = (action: string, item: ITemplate[], idx: number) => {
    if (action=="PREVIEW")
      setViewPreview(true)
    else  
      onActionsTemplate(action, item, idx);
  }

  const tooltipValidate = (colName: string) => {
    if(colName==='name'){
    const compare = textName.current.scrollWidth > textName.current.clientWidth;
    if(compare)showTooltipname(true);
    }
    else if (colName==='state')
    {
      showTooltipstate(true)
    }
    else{
      const compare = textTags.current.scrollWidth > textTags.current.clientWidth;
      if(compare)showTooltiptag(true);
    }
  };

  const handleOpenOptions = (e: any) => {
    e.stopPropagation();
    setOpenOptions(!openOptions);
    setCoordinates({x: e.clientX, y: e.clientY});
  }

  const handleOpenEditor = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.shiftKey && handleSelectedIndexes) {
      if (selected) {
        handleSelectedIndexes(idx, 'REMOVE');
      } else {
        handleSelectedIndexes(idx, 'ADD');
      }
      return;
    }
    if (item.parsedTree) window.open(`/editor/template/${item.id}`);
  }

  const handleContextMenu = (e: any) => {
    if (selected && setOpen) {
      e.preventDefault();
      setOpen(true);
    }
  }
  
  return (
    <S.Root id={`item-row-${item?.id}`}>
      <S.Row
        border={selected ? true : false}
        onClick={(e) => handleOpenEditor(e)}
        onContextMenu={handleContextMenu}
      >
        <S.ColName ref={textName} onMouseOver={()=>tooltipValidate('name')} onMouseOut={()=>showTooltipname(false)}>
            {item.name}
        </S.ColName>
        <S.Tooltip style={{display: tootltipName?'block':'none'}}>{item.name}</S.Tooltip>
        <S.ColTags ref={textTags} onMouseOver={()=>tooltipValidate('tags')} onMouseOut={()=>showTooltiptag(false)}>
            <S.Text>
              <S.Label>Tags:</S.Label>
              {item.tags.designType}, {item.tags.platform}, {getOEMName(item.tags.oem, dsConfig)}
            </S.Text>
        </S.ColTags>
        <S.Tooltip style={{display: tootltipTags?'block':'none', left:'29%'}}>
            <S.FormatLabel>{item.tags.designType}</S.FormatLabel>
            <S.FormatLabel>{item.tags.platform}</S.FormatLabel>
            <S.FormatLabel>{ getOEMName(item.tags.oem, dsConfig) }</S.FormatLabel>
        </S.Tooltip>
        <S.ColSize>
            <S.Text>
              {
                item.tags?.formats && item.tags.formats.length > 0 ?
                  item.tags.formats.length === 1 ?
                    `${item.tags.formats[0].width}px - ${item.tags.formats[0].height}px`
                  :
                    `${item.tags.formats.length} sizes`
                :
                  `No Format`
              }
            </S.Text>
            {
              item.tags?.formats && item.tags.formats.length > 1 &&
              <S.FormatsAbsoluteContainer>
                <S.FormatsContainer>
                  {
                    item.tags.formats.map((format: any, index: number) => {
                      return (
                        <S.FormatLabel key={index} >
                          {`${format.name} - ${format.width}px x ${format.height}px`}
                        </S.FormatLabel>
                      )
                    })
                  }
                </S.FormatsContainer>
              </S.FormatsAbsoluteContainer>
            }
        </S.ColSize>
        <S.ColEdited>
            <S.Label>Last edited:</S.Label>
            <S.Text>{ new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(item.updateDate))}
            </S.Text>
        </S.ColEdited>
        <S.ColDescribed ref={textState} onMouseOver={()=>tooltipValidate('state')} onMouseOut={()=>showTooltipstate(false)}>            
            { item.described 
            ?<BlackCheckIcon/>
            :<WarningIcon/>}
        </S.ColDescribed>
        <S.Tooltip style={{display: tootltipState?'block':'none', left:'80%'}}>{
            item.described?`Status: No Errors`:`Error: No elements described`
        }</S.Tooltip>
        <S.ColState status={item.templateStatus}>
            {item.templateStatus[0].toUpperCase()+item.templateStatus.substring(1).toLowerCase()}
            <S.IconContainer onClick={handleOpenOptions}>
              <OptionIcon/>
            </S.IconContainer>
        </S.ColState>
      </S.Row>
      {
        openOptions && 
        <Options
        index={idx}
        open={openOptions}
        setOpen={setOpenOptions}
        coordinates={coordinates}
        item={item}
        designType={item.tags.designType}
        createdDate={new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(item.createdDate))}
        userName={item.createdBy?.name ? item.createdBy.name : "Default User"}
        lastEditedDate={new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(item.updateDate))}
        onActionsTemplate={handleActionsTemplate}
        />
      }
      {
        viewPreview &&
      <FullPreview
          open={viewPreview}
          setOpen={setViewPreview}
          item={item}
          onAcion={()=>{}}        
          onTagSelected={(tag:string)=>{            
            templateContext.setSearchValue(tag)    
            templateContext.setForceSearch(true)
          }}  
        />
      }
    </S.Root >
  );
}

export default ItemTemplate;